declare namespace $ {

	export class $shm_hitalama_map_page_keyboard_move extends $mol_object {
		Map_page( ): $shm_hitalama_map_page
		auto( ): any
	}
	
}

//# sourceMappingURL=move.view.tree.d.ts.map